import { openDB } from 'idb';

class IndexedDbService {
    constructor(dbName, version = 1) {
        this.dbName = dbName;
        this.version = version;
        this.db = null;
    }
    static async getVersion(dbName) {
        try {
            const tempDb = await openDB(dbName);
            const currentVersion = tempDb.version;
            tempDb.close();
            return currentVersion;
        } catch (err) {
            console.error('Error opening IndexedDB:', err);
            throw err;
        }
    }
    /**
     * Open DB and ensure the `categories` store exists.
     * Browsers may hold an old `tazej` DB version that never ran `upgrade` (no object stores).
     * Opening at the same version skips `upgrade`, so we bump until `categories` exists.
     */
    async openConnection() {
        const storeDefs = [
            { name: 'categories', keyPath: 'id', autoIncrement: false },
        ];

        const ensureStoresInUpgrade = (db) => {
            storeDefs.forEach((store) => {
                if (!db.objectStoreNames.contains(store.name)) {
                    db.createObjectStore(store.name, {
                        keyPath: store.keyPath,
                        autoIncrement: store.autoIncrement,
                    });
                }
            });
        };

        let requestedVersion =
            this.version != null && !isNaN(this.version) ? this.version : 1;

        for (let attempt = 0; attempt < 12; attempt++) {
            this.db = await openDB(this.dbName, requestedVersion, {
                upgrade(db) {
                    ensureStoresInUpgrade(db);
                },
            });

            if (this.db.objectStoreNames.contains('categories')) {
                this.version = this.db.version;
                return this.db;
            }

            const current = this.db.version;
            this.db.close();
            requestedVersion = current + 1;
        }

        throw new Error('IndexedDB: could not ensure categories object store');
    }

    async add(storeName, data) {
        return await this.db.add(storeName, data);
    }

    async get(storeName, id) {
        return await this.db.get(storeName, id);
    }

    async getAll(storeName) {
        return await this.db.getAll(storeName);
    }

    async update(storeName, data) {
        return await this.db.put(storeName, data);
    }

    async delete(storeName, id) {
        return await this.db.delete(storeName, id);
    }

    async clear(storeName) {
        return await this.db.clear(storeName);
    }
}

export default IndexedDbService;